export const sharedMapPropsMixin = {
  props: {
    organisationBoundaries: {
      type: Object,
      required: false
    },
    // used in `mapBoundariesMixin`
    filteredBoundaries: {
      type: Object,
      required: false
    },
    searchStrategy: {
      type: String,
      required: false,
      default: 'distance_from_location'
    }
  }
}
